module.exports = __webpack_public_path__ + "static/the-happiness-hypothesis-325e250a714e02b556493362345f00e6.jpg";